import { Fragment } from "react";
import { jsx, Box } from "theme-ui";
import { Store } from "../types";
import {
  daysOfTheWeek,
  HourDetails,
  createHourString,
} from "../utils/storeHours";

const StoreOpenClose: React.FC<{
  store: Store;
  hoursDetailed: HourDetails | null;
  className?: string;
}> = ({ store, hoursDetailed }) => {
  const isOpen24Hours =
    (hoursDetailed?.ranges || [])[0]?.deltas?.min == 0 &&
    (hoursDetailed?.ranges || [])[0]?.deltas?.max == 10079;

  return (
    <Fragment>
      {!hoursDetailed || new Date(store.storeOpenDate) >= new Date() ? (
        "Coming Soon!"
      ) : store.temporarilyClosed &&
        new Date(store.publishedAt) > new Date() ? (
        "Temporarily Closed"
      ) : isOpen24Hours ? (
        "Open 24 hours"
      ) : (
        <Fragment>
          {hoursDetailed?.isOpen
            ? "Open"
            : hoursDetailed?.holiday
            ? "Closed for " + hoursDetailed.holiday
            : "Closed"}{" "}
          {hoursDetailed.openCloseDate && (
            <Fragment>
              {" "}
              &bull;{" "}
              <span
                sx={{
                  whiteSpace: "nowrap",
                }}
              >
                {hoursDetailed?.openCloseDate && hoursDetailed.isOpen
                  ? "Closes at "
                  : "Opens at "}
                {createHourString(
                  hoursDetailed?.openCloseDate.getHours() ?? 0,
                  hoursDetailed?.openCloseDate.getMinutes() ?? 0
                )}
                {hoursDetailed?.openCloseDate.getDate() !==
                  new Date().getDate() &&
                  " on " +
                    daysOfTheWeek[hoursDetailed?.openCloseDate?.getDay() ?? 0]}
              </span>
            </Fragment>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};
export default StoreOpenClose;
